module.exports = __webpack_public_path__ + "static/media/donut.5d44a272.gif";